class LeadRoomInventoryModel {
  static get PACKED_BY() {
    return {
      MOVERS: 1,
      CUSTOMER: 2,
    }
  }
}

export default LeadRoomInventoryModel
